<template>
	<popup
			@updateClosePopup="onClose"
			@updateSave="onSave"
			height-head="40px"
			width="880px"
			:fullscreen="false"
			:title="`${getTitle} contract`"
	>
		<div class="contractPopup">
			<div class="groupFieldWrapper">
				<div class="groupFieldWrapper_title">Contract info</div>
				<div class="groupField_wrap">
					<field
							:class-error="$v.contract_type.$error"
							margin="0 10px 0 0"
							width="200px"
							label="Contract type"
							placeholder="Select contract type"
							@updateAutocomplete="onAutocomplete($event, 'contract_type')"
							:autocompleteValue="contract_type"
							:items="driverList"
							:isClearable="false"
							is-autocomplete
							is-required
					></field>
					<field
							margin="0 10px 0 0"
							width="200px"
							label="Contract ID"
							placeholder="Enter contract ID"
							:setInputValue="id"
							is-readonly
					></field>
					<field
							:class-error="$v.date_start.$error"
							margin="0 10px 0 0"
							width="200px"
							type="text"
							label="Contract start date"
							placeholder="Enter date"
							:dateValue="date_start"
							@updateDate="onDate($event, 'date_start')"
							is-date
							is-no-title
							is-required
					></field>
					<field
							margin="0"
							width="200px"
							type="text"
							label="Contract end date"
							placeholder="Enter date"
							:dateValue="date_end"
							@updateDate="onDate($event, 'date_end')"
							is-date
							is-no-title
					></field>
				</div>
			</div>
			<div class="groupFieldWrapper">
				<div class="groupFieldWrapper_title">Driver company info</div>
				<div class="groupField_wrap">
					<field
							margin="0 10px 0 0"
							width="410px"
							label="Company name"
							placeholder="Enter company name"
							:setInputValue="driver_company"
							@updateInput="onInput($event, 'driver_company')"
					></field>
					<field
							margin="0 10px 0 0"
							width="410px"
							label="Address"
							placeholder="Enter address"
							:setInputValue="address"
							@updateInput="onInput($event, 'address')"
					></field>
				</div>
				<div class="groupField_wrap">
					<field
							margin="0 10px 0 0"
							width="410px"
							label="Fein #"
							placeholder="Enter Fein"
							:setInputValue="fein"
							@updateInput="onInput($event, 'fein')"
					></field>
					<field
							:class-error="$v.file.value.$error"
							margin="0 10px 0 0"
							width="410px"
							label="File"
							placeholder="Add file"
							:setInputValue="file.name"
							:is-file-icon="!!file.name"
							color-icon="#19BC38"
							@updateFile="setNewItem($event)"
							@updateView="onView"
							is-file
							is-readonly
							is-required
					></field>
				</div>
			</div>
			<div class="groupFieldWrapper">
				<div class="groupFieldWrapper_title">Payment rules</div>
				<div class="groupField_wrap">
					<field
							margin="0 10px 0 0"
							width="410px"
							label="Payment type"
							placeholder="Select payment type"
							@updateAutocomplete="onAutocomplete($event, 'payment_type')"
							:autocompleteValue="payment_type"
							:items="getPaymentsTypeList"
							:isClearable="false"
							is-autocomplete
					></field>
					<field
							:class-error="$v.amount.$error"
							margin="0 10px 0 0"
							width="200px"
							type="number"
							label="Payment amount"
							placeholder="Enter value"
							:setInputValue="amount"
							:icon="getPaymentIcon ? 'percent' : 'dollar'"
							@updateInput="onInput($event, 'amount')"
							is-required
					></field>
					<field
							:class-error="$v.min_distance.$error"
							margin="0 10px 0 0"
							width="200px"
							type="number"
							label="Minimum distance"
							placeholder="Enter value"
							icon="mi"
							:setInputValue="min_distance"
							@updateInput="onInput($event, 'min_distance')"
							is-required
					></field>
				</div>
				<div class="groupField_wrap mb-20">
					<field
							:class-error="$v.extra_stop_rate.$error"
							margin="0 10px 0 0"
							width="200px"
							type="number"
							label="Extra-stop rate"
							placeholder="Enter value"
							icon="dollar"
							:setInputValue="extra_stop_rate"
							@updateInput="onInput($event, 'extra_stop_rate')"
							is-required
					></field>
					<field
							:class-error="$v.layover_rate.$error"
							margin="0 10px 0 0"
							width="200px"
							type="number"
							label="Layover per hour rate"
							placeholder="Enter value"
							icon="dollar"
							:setInputValue="layover_rate"
							@updateInput="onInput($event, 'layover_rate')"
							is-required
					></field>
					<field
							:class-error="$v.detention_rate.$error"
							margin="0 10px 0 0"
							width="200px"
							type="number"
							label="Detention per hour rate"
							placeholder="Enter value"
							icon="dollar"
							:setInputValue="detention_rate"
							@updateInput="onInput($event, 'detention_rate')"
							is-required
					></field>
					<field
							:class-error="$v.tarp_rate.$error"
							margin="0 10px 0 0"
							width="200px"
							type="number"
							label="TARP rate"
							placeholder="Enter value"
							icon="dollar"
							:setInputValue="tarp_rate"
							@updateInput="onInput($event, 'tarp_rate')"
							is-required
					></field>
				</div>
			</div>
		</div>
	</popup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// shared
import Popup from "@/shared/Popup/Popup";
// validations
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
	name: "ContractPopup",
	mixins: [ validationMixin ],
	components: { Popup },
	props: {
		driverList: Array,
		driverId: Number,
		row: Object
	},
	computed: {
		...mapGetters([ 'driversList', 'driversItem' ]),
		getPaymentIcon() {
			return this.payment_type === 1;
		},
		getTitle() {
			if (this.row) return 'Edit';
			return 'Add';
		},
		getPaymentsTypeList() {
			return this.driversItem.payment_type;
		}
	},
	data: () => ({
		isContractPopup: true,
		date_start: '',
		date_end: '',
		create_at: '',
		address: '',
		driver_company: '',
		payment_type: 2,
		contract_type: null,
		amount: null,
		extra_stop_rate: null,
		layover_rate: null,
		detention_rate: null,
		tarp_rate: null,
		min_distance: null,
		fein: '',
		id: '',
		file: {
			name: "",
			value: ""
		}
	}),
	validations: {
		file: {
			value: { required }
		},
		date_start: { required },
		extra_stop_rate: { required },
		layover_rate: { required },
		detention_rate: { required },
		tarp_rate: { required },
		min_distance: { required },
		contract_type: { required },
		amount: { required }
	},
	methods: {
		...mapActions([ 'onSetContract', 'onContractUpdate', 'setAlert', 'actionPreloader' ]),
		onClose() {
			this.$emit('updateClose');
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				this.actionPreloader(true);
				// eslint-disable-next-line no-unused-vars
				const { isContractPopup, create_at, ...obj } = this.$data;
				let error = null;
				if (this.row) {
					error = await this.onContractUpdate(obj);
					this.actionPreloader(false);
				} else {
					obj.id = this.driverId;
					error = await this.onSetContract(obj);
					this.actionPreloader(false);
				}

				if (!error) {
					this.onClose();
				} else {
					await this.setAlert({ type: "error", message: error[0] });
				}
			}
		},
		onDate(date, key) {
			this[key] = date;
		},
		onAutocomplete({ value }, key) {
			this[key] = value?.id ?? null;
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		setNewItem(e) {
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.file = {
					name: iFile.name,
					value: reader.result
				};
			};
		},
		onView() {
			const { value } = this.file;
			this.$emit('updateView', value);
		}
	},
	mounted() {
		if (this.row) {
			const {
				date_start,
				date_end,
				create_at,
				address,
				driver_company,
				payment_type_id,
				contract_type_id,
				amount,
				extra_stop_rate,
				layover_rate,
				detention_rate,
				tarp_rate,
				min_distance,
				fein,
				file,
				file_name,
				id
			} = this.row;
			this.payment_type = payment_type_id;
			this.contract_type = contract_type_id;

			this.date_start = date_start;
			this.date_end = date_end;
			this.create_at = create_at;
			this.address = address;
			this.driver_company = driver_company;
			this.amount = amount;
			this.extra_stop_rate = extra_stop_rate;
			this.layover_rate = layover_rate;
			this.detention_rate = detention_rate;
			this.tarp_rate = tarp_rate;
			this.min_distance = min_distance;
			this.fein = fein;
			this.id = id ?? '';
			this.file = {
				name: file_name,
				value: file
			};
		}
	}
};
</script>

<style scoped lang="scss">
@import "ContractPopup";
</style>
